(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["intag-delivery-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('intag-delivery-ticker')) {
    customElements.define('intag-delivery-ticker', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const toggle = this.querySelector('.intag-delivery-ticker__toggle');
        if (toggle) {
          toggle.hidden = false;
          toggle.addEventListener('click', () => {
            const paused = this.toggleAttribute('data-paused');
            toggle.setAttribute('aria-pressed', String(paused));
            toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
          }, options);
        }
        const visibility = () => this.toggleAttribute('data-hidden', document.hidden);
        document.addEventListener('visibilitychange', visibility, options);
        visibility();
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.toggleAttribute('data-offscreen', !entries[0].isIntersecting);
          });
          this.observer.observe(this);
        }
        document.addEventListener('shopify:section:select', event => {
          if (event.target.contains(this)) this.setAttribute('data-editor', '');
        }, options);
        document.addEventListener('shopify:section:deselect', event => {
          if (event.target.contains(this)) this.removeAttribute('data-editor');
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
